module.exports = __webpack_public_path__ + "static/img/interface _authorization_no-data.289ac4e9.png";